import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import MessageForm from '../containers/MessageFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class MessageAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `MessageAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('message_route_add')} />
          <MessageForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default MessageAddScreen;

Logger.log('silly', `MessageAddScreen loaded.`);
